<template>
  <dl class="accordion-box" role="presentation">
    <slot></slot>
  </dl>
</template>

<script>
export default {
  name: 'BaseAccordion',
  data () {
    return {
      Accordion: {
        count: 0,
        active: null
      }
    }
  },
  provide () {
    return { Accordion: this.Accordion }
  }
}
</script>

<style lang="sass" scoped>
.accordion-box
  margin: 0
</style>
